import React from 'preact';

export default function MobileBotNavExpand() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 90 20">
      <g id="Collapse button">
        <g id="Arrow">
          <path id="Rectangle 1829" d="M0 20L10.7058 1.95872C11.4264 0.744436 12.7338 3.25809e-06 14.1458 3.19637e-06L75.8542 4.99003e-07C77.2662 4.37283e-07 78.5736 0.744433 79.2942 1.95872L90 20L0 20Z" fill="#333333" />
          <path id="Polygon 9" d="M45 5L53.6603 13H36.3397L45 5Z" fill="white" />
        </g>
      </g>
    </svg>
  );
}